import { Box, Typography } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

import Container from './Container'
import { getCapacity, getPower } from '../../utils'
import { Retrofit } from 'src/Libs/retrofit/models/retrofit.model'

const useStyles = makeStyles()(theme => ({
  rowElement: {
    display: 'grid',
    gridTemplateColumns: 'auto max-content max-content',
    gridTemplateRows: 'repeat(3, 1fr)',
    alignItems: 'center',
    columnGap: theme.spacing(1),
    rowGap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
}))

interface CurrentSystemInfoProps {
  retrofitData: Retrofit
}

/**
 * Component to display current system info
 */
const CurrentSystemInfo: React.FC<CurrentSystemInfoProps> = ({ retrofitData }) => {
  const { configuration } = retrofitData
  const { classes } = useStyles()
  const { t } = useCustomTranslation()

  if (!configuration) {
    return null
  }

  const rowElements = [
    {
      label: t('retrofit-check.available.current-system.battery-modules'),
      value: configuration.currentBatteryCount,
      unit: null,
    },
    {
      label: t('retrofit-check.available.current-system.power'),
      value: getPower(configuration),
      unit: t('retrofit-check.available.current-system.power-unit'),
    },
    {
      label: t('retrofit-check.available.current-system.capacity'),
      value: getCapacity(configuration),
      unit: t('retrofit-check.available.current-system.capacity-unit'),
    },
  ]

  return (
    <Container>
      <Typography variant="h4">{t('retrofit-check.available.current-system.title')}</Typography>
      <Box className={classes.rowElement}>
        {rowElements.map(({ label, value, unit }, index) => (
          <>
            <Box sx={{ gridColumn: '1', gridRow: index + 1 }}>
              <Typography variant="h5">{label}</Typography>
            </Box>
            <Box sx={{ gridColumn: '2', gridRow: index + 1, justifySelf: 'end', alignSelf: 'end' }}>
              <Typography variant="h2">{value}</Typography>
            </Box>
            <Box sx={{ gridColumn: '3', gridRow: index + 1, alignSelf: 'end' }}>
              <Typography variant="subtitle2" sx={{ lineHeight: 'inherit' }}>
                {unit}
              </Typography>
            </Box>
          </>
        ))}
      </Box>
    </Container>
  )
}

export default CurrentSystemInfo
